// Port of stpancras-storybook-app/src/utils/colors.js (the light palette used
// by `aha-avatar`). Keeping the exact 26 RGBA values + index-by-mod scheme
// means a given user gets the same colour they see in the presenter app.
// See AHA-42835.
const AVATAR_COLORS = [
  "rgba(78, 170, 241, 1)", // blue
  "rgba(255, 175, 9, 1)", // yel
  "rgba(40, 194, 112, 1)", // green
  "rgba(253, 93, 161, 1)", // pink
  "rgba(118, 105, 191, 1)", // purple
  "rgba(156, 162, 174, 1)", // grey
  "rgba(79, 151, 241, 1)", // blue 2
  "rgba(255, 199, 0, 1)", // yel 2
  "rgba(40, 194, 129, 1)", // green 2
  "rgba(253, 93, 142, 1)", // pink 2
  "rgba(127, 105, 191, 1)", // purple 2
  "rgba(156, 165, 174, 1)", // grey 2
  "rgba(77, 183, 240, 1)", // blue 3
  "rgba(255, 156, 16, 1)", // orange
  "rgba(40, 194, 99, 1)", // green 3
  "rgba(253, 92, 173, 1)", // pink 3
  "rgba(110, 105, 191, 1)", // purple 3
  "rgba(162, 155, 175, 1)", // grey purple
  "rgba(116, 76, 242, 1)", // purple 4
  "rgba(154, 240, 37, 1)", // neon green
  "rgba(43, 158, 195, 1)", // sky
  "rgba(253, 152, 89, 1)", // light orange
  "rgba(182, 105, 191, 1)", // weird purple
  "rgba(155, 170, 174, 1)", // grey blue
  "rgba(74, 225, 239, 1)", // fresh blue
  "rgba(255, 100, 28, 1)", // fresh orange
] as const;

// Mirrors `colorUtil.getRandomColor(id)`: stable seed → stable colour. When
// `id` is absent we fall back to the first character's char code (parity
// with `aha-avatar`'s `avatarColor` computed).
export function getAvatarColor(id: number | string | null | undefined, fallbackName: string): string {
  let seed: number | null = null;
  if (typeof id === "number" && Number.isFinite(id)) {
    seed = id;
  } else if (typeof id === "string" && id.length > 0) {
    const n = Number(id);
    if (Number.isFinite(n)) seed = n;
  }
  if (seed === null) {
    const trimmed = fallbackName.trim();
    seed = trimmed.length > 0 ? trimmed.charCodeAt(0) : 0;
  }
  // Guard against negative ids — JS `%` is sign-preserving.
  const idx = ((seed % AVATAR_COLORS.length) + AVATAR_COLORS.length) % AVATAR_COLORS.length;
  return AVATAR_COLORS[idx];
}

// Mirrors the presenter `textAvatar` filter (filters.js:126-133): trim, take
// the first Unicode grapheme. Empty input → a single space so the circle
// still has something to lay out.
export function avatarInitial(name: string | null | undefined): string {
  const trimmed = (name ?? "").trim();
  if (!trimmed) return " ";
  return trimmed.match(/./u)?.[0]?.toUpperCase() ?? " ";
}
